import { posthogKey } from "@/config";
import posthog from "posthog-js";

// Initialize PostHog asynchronously to avoid blocking the main thread
if (typeof window !== "undefined") {
  // Defer PostHog initialization to avoid blocking the main thread
  setTimeout(() => {
    posthog.init(posthogKey, {
      api_host: "/ingest",
      ui_host: "https://eu.i.posthog.com",
      defaults: "2025-05-24",
      opt_out_capturing_by_default: process.env.NODE_ENV === "development",
      capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
      // debug: process.env.NODE_ENV === "development",
      loaded: (ph) => {
        let checkInterval: NodeJS.Timeout;

        // this will be called every time a new sesson starts
        ph.onSessionId((sessionId) => {
          clearInterval(checkInterval);

          // setup a check for the condition that means the recording is interesting enough to be watched
          checkInterval = setInterval(() => {
            // we want to read the session data, but not change it, so we pass `true`
            const {
              lastActivityTimestamp,
              // or maybe sessionStartTimestamp,
              sessionId,
            } = ph.sessionManager?.checkAndGetSessionAndWindowId(true) as {
              lastActivityTimestamp: number;
              sessionId: string;
            };

            const sinceLastActivity = Math.abs(
              new Date().getTime() - lastActivityTimestamp,
            );
            const fiveMinutesInMillis = 5 * 60 * 1000;
            if (sinceLastActivity > fiveMinutesInMillis) {
              // capture an event that will be used to trigger the posthog destination
              ph.capture("session_idle_for_five_minutes", {
                sessionURL: ph.get_session_replay_url({ withTimestamp: true }),
                idleSessionId: sessionId,
              });

              // clear the interval so we only send the event once
              clearInterval(checkInterval);
            }
          }, 5000);
        });
      },
    });
  }, 0);
}
